/* === BEGIN imported: customComponent/keenSlider.jsx (verbatim from plugin) === */
import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation, Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import NumberCounter from "@/customComponents/uiComponents/global/NumberCounter.jsx";
import {Loader} from "@/customComponents/uiComponents/Loader.jsx";

/**
 * `readOnly` (dashboard-only addition to the imported plugin component): drop the
 * +/- counter and show the seat itself larger and centred. The /help FAQ reuses this
 * carousel purely to ILLUSTRATE the seat range — there is no order to add to from
 * there, so a counter would both mislead and write stray `hopn-counter-*` keys.
 */
export function KeenSlider(props) {
    return (
        <div className={`hopn-carseat-slider${props.detailsView ? " detailed" : ""}${props.readOnly ? " is-readonly" : ""}`}>
            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={15}
                navigation={false}
                pagination={{clickable: true}}
                style={{width: "100%"}}
                autoHeight={false}
                breakpoints={{
                    0: {
                        slidesPerView: props.mobileItem ?? 2.3,
                        spaceBetween: 8
                    },
                    991: {
                        slidesPerView: props.itemNumber,
                    },
                }}
            >
                {
                    props.items.length === 0
                        ? (<center><Loader/></center>)
                        :
                        (
                            props.items.map((item, index) => (
                                <SwiperSlide key={index}>
                                    <div className="hopn-carseat-item" style={{textAlign: "center"}}>
                                        {props.detailsView ? (
                                            <>
                                                <h5>{item.label}</h5>
                                                <div className="hopn-item-image">
                                                    <img src={item.image_url} alt={item.label}/>
                                                </div>
                                                <p>{item.description}</p>
                                            </>
                                        ) : (
                                            <div className="hopn-item-image">
                                                <h5>{item.label}</h5>
                                                <img src={item.image_url} alt={item.label}/>
                                            </div>
                                        )}
                                        {!props.readOnly && (
                                            <div className="hopn-counter-small">
                                                <NumberCounter id={`carSeat-${item.id}`} variant="booking"/>
                                            </div>
                                        )}
                                    </div>
                                </SwiperSlide>
                            ))
                        )
                }
            </Swiper>
        </div>
    );
}
/* === END imported: customComponent/keenSlider.jsx === */
